export default {
    state: () => ({
        /**
         * @type {Object<string, QuestionAnswerInterface>}
         */
        questionsAttempts: {}
    }),
    getters: {
        questionsAttempts: state => {
            return state.questionsAttempts
        },
        questionsAttemptsArray: state => {
            return Object.values(state.questionsAttempts)
        },
    },

    mutations: {
        setFlagged (state, { key, flagged }) {
            const attempt = state.questionsAttempts[key]
            if (!attempt) {
                state.questionsAttempts[key] = {
                    flagged: flagged
                }
            }
        },
        /**
         * @param state
         * @param {string} key
         * @param {QuestionAnswerInterface} attempt
         */
        setQuestionAttempt (state, { key, attempt }) {
            state.questionsAttempts[key] = attempt
        }
    },

    actions: {
        setFlaggedQuestion ({ commit }, { id, flagged }) {
            commit('setFlagged', { id, flagged })
        },
        /**
         * @param commit
         * @param {string} key
         * @param {QuestionAnswerInterface} attempt
         */
        setQuestionAttempt ({ commit }, { key, attempt }) {
            commit('setQuestionAttempt', { key, attempt })
        }
    }
}
